<template>
  <div class="main">
    <b-tabs v-model="tabIndex">
      <b-tab :title="$t('Campaigns')">
        <template #title>
          <strong style="font-weight: 500; color: black">{{ $t('Campaigns') }}</strong>
        </template>
        <div class="table-header-actions">
          <div class="left-actions">
            <button v-b-modal.add-campaign class="button">
              <b-icon-plus />
              {{ $t('AddCampaign') }}
            </button>
          </div>

          <!-- <div class="center-actions">
            <button class="button" @click="openAddOccasionModal">
              <b-icon-plus />
              {{ $t('Add Occasion') }}
            </button>
          </div> -->
        </div>

        <div class="table-container">
          <table class="team_table">
            <thead>
              <tr>
                <th>{{ $t('CampaignName') }}</th>
                <th>{{ $t('Type') }}</th>
                <th>{{ $t('occasion') }}</th>
                <th>{{ $t('Budget') }}</th>
                <th>{{ $t('StartDate') }}</th>
                <th>{{ $t('EndDate') }}</th>
                <th>{{ $t('leads') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(campaign, index) in filteredCampaigns" :key="index" class="hover-row">
                <td>{{ campaign.name || campaign.campaign || '' }}</td>
                <td>{{ campaign.type || '-' }}</td>
                <td>{{ campaign.lovCampaignOccasionName || campaign.occasionName || (campaign.lovCampaignOccasionId || '') }}</td>
                <td>{{ campaign.budget || campaign.Budget || '' }}</td>
                <td>{{ campaign.startTime ? (new Date(campaign.startTime)).toLocaleDateString() : '' }}</td>
                <td>{{ campaign.endTime ? (new Date(campaign.endTime)).toLocaleDateString() : '' }}</td>
                <td>
                  <button class="button" @click.prevent="showLeads(campaign)">{{ $t('Leads') }}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="tabIndex == 0">
          <b-pagination
            v-if="getTotalCampaigns > 15"
            v-model="currentPage"
            :total-rows="getTotalCampaigns"
            :per-page="pageSize"
            first-number
            last-number
            align="fill"
            prev-class="prev-itemi"
            next-class="next-itemi"
            class="mt-1 mb-0"
          >
            <template #prev-text>
              <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
            </template>
            <template #next-text>
              <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
            </template>
          </b-pagination>
        </div>
      </b-tab>

      <b-tab :title="$t('Occasions')">
        <template #title>
          <strong style="font-weight: 500; color: black">{{ $t('Occasions') }}</strong>
        </template>
        <div class="table-header-actions">
          <div class="left-actions">
            <button class="button" @click="openAddOccasionModal">
              <b-icon-plus />
              {{ $t('Add Occasion') }}
            </button>
          </div>
        </div>

        <div class="table-container">
          <table class="team_table">
            <thead>
              <tr>
                <th>{{ $t('Name') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(occasion, index) in getCampaignOccasions" :key="index" class="hover-row">
                <td>{{ occasion.name || occasion.lovCampaignOccasionName || '' }}</td>
              </tr>
            </tbody>
          </table>
          <div v-if="!getCampaignOccasions || !getCampaignOccasions.length" class="empty-state">
            <b-icon-inbox size="lg" class="mb-2" />
            <p>{{ $t('No occasions found.') }}</p>
          </div>
        </div>
      </b-tab>
    </b-tabs>

    <div v-if="showSlidebar" class="overlay" @click="closeSlidebar"></div>

    <div class="slidebar" :class="{ 'open': showSlidebar }">
      <div class="slidebar-header">
        <div class="header-content">
          <h4 class="slidebar-title">
            <b-icon-person-lines-fill class="mr-2" />
            {{ selectedCampaign?.name || $t('Leads') }}
          </h4>
          <p class="slidebar-subtitle">{{ $t('CampaignLeadsDetail') }}</p>
        </div>
        <button class="close-btn" @click="closeSlidebar">&times;</button>
      </div>

      <div class="slidebar-body">
        <div class="action-row">
          <button v-b-modal.add-lead-modal class="button">
            <b-icon-plus />
            {{ $t('Add Lead') }}
          </button>
        </div>

        <div class="table-responsive mt-3">
          <table class="team_table slidebar-table">
            <thead>
              <tr>
                <th>{{ $t('No') }}</th>
                <th>{{ $t('Salutation') }}</th>
                <th>{{ $t('Gender') }}</th>
                <th>{{ $t('Name') }}</th>
                <th>{{ $t('Email') }}</th>
                <th>{{ $t('Telephone') }}</th>
                <th>{{ $t('Instagram') }}</th>
                <th>{{ $t('Country') }}</th>
                <th>{{ $t('Date of birth') }}</th>
                <th>{{ $t('BillingAddress') }}</th>
                <!-- <th>{{ $t('Characteristics') }}</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(lead, i) in getCampaignLeads" :key="i" class="hover-row">
                <td class="font-weight-bold">
                  {{ i + 1 }}
                </td>
                <td>{{ lead.salutation }}</td>
                <td>{{ lead.gender || '-' }}</td>
                <td class="font-weight-bold">{{ lead.firstName }} {{ lead.lastName }}</td>
                <td>{{ lead.email }}</td>
                <td>{{ lead.telephoneNumber }}</td>
                <td>
                  <a
                    v-if="lead.instagramHandle"
                    :href="'https://www.instagram.com/' + lead.instagramHandle.replace(/^@/, '')"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {{ lead.instagramHandle }}
                  </a>
                  <span v-else>-</span>
                </td>
                <td>{{ getCountryName(lead.countryCode) }}</td>
                <td>{{ lead.dateOfBirth }}</td>
                <td>
                  <div v-if="lead.billingAddressDto" class="billing-address">
                    {{ formatAddress(lead.billingAddressDto) }}
                  </div>
                  <span v-else>-</span>
                </td>
                <!-- <td>
                  <button
                    v-if="hasLeadCharacteristics(lead)"
                    class="button"
                    @click.prevent="openLeadCharacteristics(lead)"
                  >
                    {{ $t('Characteristics') }}
                  </button>
                </td> -->
              </tr>
            </tbody>
          </table>
          
          <div v-if="!getCampaignLeads || !getCampaignLeads.length" class="empty-state">
            <b-icon-inbox size="lg" class="mb-2" />
            <p>{{ $t('No leads found for this campaign.') }}</p>
          </div>
        </div>
      </div>
    </div>
    

    <AddCampaignModal @addCampaign="handleAddCampaign" />
    <AddOccasionModal ref="addOccasionModal" @refreshOccasions="fetchCampaignOccasions" />
    <AddCampaignLeadModal :campaignId="selectedCampaignId" @leadAdded="handleLeadAdded" />
      <!-- <EditCharacteristics ref="editCharModal" :characteristics="selectedLeadCharacteristics" /> -->
  </div>
</template>

<script>
import AddCampaignModal from '@/components/campaign/modal/AddCampaignModal.vue'
import AddOccasionModal from '@/components/campaign/modal/AddOccasionModal.vue'
import AddCampaignLeadModal from '@/components/campaign/modal/AddCampaignLeadModal.vue'
// import EditCharacteristics from '@/components/clients/modals/EditCharacteristics.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    AddCampaignModal,
    AddCampaignLeadModal,
    AddOccasionModal,
    // EditCharacteristics,
  },
  data() {
    return {
      tabIndex: 0,
      searchQuery: '',
      showSlidebar: false,
      selectedCampaign: null,
      selectedCampaignId: null,
      pageSize: 15,
      currentPage: 1,
      countryCodeMap: {
        'XK': 'Kosovo',
        'AL': 'Albania',
        'AD': 'Andorra',
        'AT': 'Austria',
        'BY': 'Belarus',
        'BE': 'Belgium',
        'BA': 'Bosnia and Herzegovina',
        'BG': 'Bulgaria',
        'HR': 'Croatia',
        'CY': 'Cyprus',
        'CZ': 'Czech Republic',
        'DK': 'Denmark',
        'EE': 'Estonia',
        'FI': 'Finland',
        'FR': 'France',
        'DE': 'Germany',
        'GR': 'Greece',
        'HU': 'Hungary',
        'IS': 'Iceland',
        'IE': 'Ireland',
        'IT': 'Italy',
        'LV': 'Latvia',
        'LI': 'Liechtenstein',
        'LT': 'Lithuania',
        'LU': 'Luxembourg',
        'MT': 'Malta',
        'MD': 'Moldova',
        'MC': 'Monaco',
        'ME': 'Montenegro',
        'NL': 'Netherlands',
        'MK': 'North Macedonia',
        'NO': 'Norway',
        'PL': 'Poland',
        'PT': 'Portugal',
        'RO': 'Romania',
        'RU': 'Russia',
        'SM': 'San Marino',
        'RS': 'Serbia',
        'SK': 'Slovakia',
        'SI': 'Slovenia',
        'ES': 'Spain',
        'SE': 'Sweden',
        'CH': 'Switzerland',
        'UA': 'Ukraine',
        'GB': 'United Kingdom',
        'US': 'United States',
        'CN': 'China',
        'IN': 'India',
        'JP': 'Japan',
        'BR': 'Brazil',
        'CA': 'Canada',
        'AU': 'Australia',
        'MX': 'Mexico',
        'ZA': 'South Africa',
        'KR': 'South Korea',
        'TR': 'Turkey',
      },
    }
  },
  computed: {
    ...mapGetters(['getCampaigns', 'getCampaignLeads', 'getTotalCampaigns', 'getCampaignOccasions']),
    filteredCampaigns() {
      if (!this.searchQuery) return this.getCampaigns;
      const query = this.searchQuery.toLowerCase();
      return this.getCampaigns.filter(c => {
        const name = (c.name || c.campaign || '').toLowerCase();
        const occasion = (c.lovCampaignOccasionName || c.occasionName || '').toLowerCase();
        return name.includes(query) || occasion.includes(query);
      });
    }
  },
  watch: {
    currentPage(value) {
      this.campaignPagination({ pageNumber: value, pageSize: this.pageSize });
    },
  },
  methods: {
    ...mapActions({
      addCampaignAction: 'addCampaign',
      campaignPagination: 'campaignPagination',
      campaignLeads: 'campaignLeads',
      fetchCampaignOccasions: 'fetchCampaignOccasions',
      fullUserById: 'fullUserById',
    }),
    formatAddress(address) {
      if (!address) return '-';
      
      let streetPart = address.street || '';
      if (address.houseNumber) {
        streetPart += ` ${address.houseNumber}`;
      }
      const cityPart = address.city || '';
      
      const parts = [
        streetPart.trim(),
        cityPart,
        address.country || ''
      ].filter(part => part);
      
      return parts.join('\n');
    },
    async handleAddCampaign(obj) {
      await this.addCampaignAction({
        object: obj,
        successCallback: () => {
          this.campaignPagination({ pageNumber: 1, pageSize: this.pageSize });
        },
      });
    },
    openAddOccasionModal() {
      this.$refs.addOccasionModal.openModal()
    },
    async showLeads(campaign) {
      const campaignId = campaign.campaignId || campaign.id;
      if (!campaignId) return;
      this.selectedCampaignId = campaignId;
      await this.campaignLeads({ campaignId, pageNumber: 1, pageSize: 15 });
      this.selectedCampaign = campaign;
      this.showSlidebar = true;
    },
    // openLeadCharacteristics(lead) {
    //   // extract possible characteristic fields from lead
    //   const chars = {
    //     favoriteColor: lead.favoriteColor || lead.characteristic?.favoriteColor || null,
    //     favoriteDress: lead.favoriteDress || lead.characteristic?.favoriteDress || null,
    //     generalDescription: lead.generalDescription || lead.characteristic?.generalDescription || null,
    //   }
    //   this.selectedLeadCharacteristics = chars
    //   // show modal inside EditCharacteristics component
    //   this.$nextTick(() => {
    //     if (this.$refs.editCharModal && this.$refs.editCharModal.$refs && this.$refs.editCharModal.$refs.modal) {
    //       this.$refs.editCharModal.$refs.modal.show()
    //     }
    //   })
    // },
    hasLeadCharacteristics(lead) {
      return !!(lead.favoriteColor || lead.favoriteDress || lead.generalDescription || (lead.characteristic && Object.keys(lead.characteristic).length))
    },
    closeSlidebar() {
      this.showSlidebar = false;
      this.selectedCampaign = null;
      this.selectedCampaignId = null;
    },
    handleLeadAdded() {
      this.campaignPagination({ pageNumber: 1, pageSize: this.pageSize });
      if (this.selectedCampaign) {
        this.showLeads(this.selectedCampaign);
      }
    },
    getCountryName(countryCode) {
      if (!countryCode) return '-';
      return this.countryCodeMap[countryCode] || countryCode;
    },
  },
  mounted() {
    this.campaignPagination({ pageNumber: 1, pageSize: this.pageSize });
  },
}
</script>

<style scoped>
.main {
  display: flex;
  flex-direction: column;
}

.table-header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;
  margin-bottom: 5px;
  margin-top: 20px;
  gap: 15px;
}

.left-actions,
.right-actions {
  flex: 1;
}
.right-actions {
  display: flex;
  justify-content: flex-end;
}
.center-actions {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}

.button {
  padding: 6px 12px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  background: white;
  font-size: 13px;
  cursor: pointer;
}

.search-container {
  position: relative;
  display: flex;
  align-items: center;
  width: 250px;
}
.search-input {
  width: 100%;
  padding: 6px 10px 6px 30px;
  font-size: 13px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  outline: none;
}
.search-icon {
  position: absolute;
  left: 10px;
  color: #909399;
}

.table-container {
  width: 100%;
  padding-top: 16px;
  display: flex;
}
.team_table {
  width: 100%;
  font-size: 12px;
  text-align: left;
  flex: 1;
  border-collapse: collapse;
}
.team_table thead {
  border-bottom: 1px solid #dcdfe6;
  color: #606266;
}
.team_table th {
  padding: 12px 9px;
  font-weight: 600;
}
.hover-row {
  border-bottom: 1px solid #dcdfe6;
  transition: background 0.2s;
}
.hover-row:hover {
  background-color: #f5f7fa;
}
.hover-row td {
  padding: 12px 9px;
  color: black;
}

@media screen and (max-width: 1700px) { .main { padding: 75px 10px 15px 90px; } }
@media screen and (max-width: 1200px) { .main { padding: 75px 10px 15px 10px; } }

.overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
}

.slidebar {
  width: 86%;
  max-width: 100vw;
  background: #fff;
  position: fixed;
  top: 0; right: 0; bottom: 0;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  z-index: 1000;
}

.slidebar.open { transform: translateX(0); }

@media screen and (max-width: 992px) { .slidebar { width: 75%; } }
@media screen and (max-width: 768px) { .slidebar { width: 100%; } }

.slidebar-header {
  padding: 20px 25px;
  background: #f8f9fa;
  border-bottom: 1px solid #ebedf0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.slidebar-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}
.slidebar-subtitle {
  font-size: 0.85rem;
  color: #909399;
  margin: 0;
}
.close-btn {
  background: none;
  border: none;
  font-size: 28px;
  color: #909399;
  cursor: pointer;
}

.slidebar-body {
  padding: 25px;
  flex: 1;
  overflow-y: auto;
}
.action-row {
  margin-bottom: 20px;
}

.slidebar-table {
  border: 1px solid #ebedf0;
}
.slidebar-table thead th {
  background: #fafafa;
}

.billing-address {
  white-space: pre-line;
  line-height: 1.4;
  max-width: 200px;
  word-wrap: break-word;
}

.slidebar-table th:nth-child(10),
.slidebar-table td:nth-child(10) {
  min-width: 200px;
}

.empty-state {
  padding: 40px;
  text-align: center;
  color: #c0c4cc;
}
</style>